@if (data?.length > 1) {
  @if (shouldShowError()) {
    <div class="error" [id]="errorMessageId" role="alert" aria-live="assertive">{{requiredErrorText}}</div>
  } @else {
    <label
      class="re-block re-mb-3"
      [class.re-invisible]="!form.controls.selected?.value"
      [attr.for]="inputName"
    >{{ labelText }}</label>
  }
  <div class="re-relative">
    <div class="select-container">
      <select
        [formControl]="form.controls.selected"
        [class.re-font-regular]="selected?.length > 0"
        [required]="required ? 'required' : null"
        [attr.data-qa]="dataQa"
        [attr.id]="inputName"
        [attr.name]="inputName"
        [attr.aria-label]="ariaLabel || labelText"
        [attr.aria-invalid]="shouldShowError() ? 'true' : 'false'"
        [attr.aria-describedby]="shouldShowError() ? errorMessageId : null"
        (change)="selectItem($event)"
        >
        @if (required) {
          <option hidden value="">{{labelText}}</option>
        }
        @for (item of data; track item) {
          <option [value]="item.value" [selected]="selected === item.value" class="re-font-regular">{{item.label}}</option>
        }
      </select>
      <bdo-svg name="icon-edge-arrow-down" styling="iconPosition-down"></bdo-svg>
    </div>
    @if (required && (form.controls.selected.touched || forceValidate)) {
      <div class="validation-icon">
        <bdo-svg [name]="form.controls.selected.valid? 'icon-success' : 'icon-alert'" [styling]="form.controls.selected.valid? 'bdo-svg--success' : 'bdo-svg--error'"></bdo-svg>
      </div>
    }
  </div>
} @else {
  <div data-qa="single-dropdown-value">{{ labelText }} <span class="bold">{{data?.[0]?.label}}</span></div>
  <input type="hidden" [formControl]="form.controls.selected" [value]="data?.[0]?.value">
}

